import React, { useEffect, useState, Fragment, useRef, useMemo, useCallback } from 'react';
import {
    getVirtualSessionEndPoint,
    checkOutVirtualSession,
    changeAttendeeSessionStatusAgenda,
    getUserTickets,
    makeAjaxRequest
} from '../../ApiUtil';
import { sendAnalytics } from 'utils/analyticsUtils';
import { analyticsConstants } from 'constants/AnalyticsConst';
import Bowser from 'bowser';
import { StreamState } from '@bizzabo/broadcast';
import {
    redirectToBroadcast,
    isSessionStartsInMorethan,
    isMobile,
    buildNewrowUrl,
    getRestrictionReason,
    useInterval,
    getTimeToSessionStartInMs,
    isSessionEndedMoreThan,
    getTimeToSessionEndMS,
    SESSION_GRACE_TIME,
    PRE_SESSION_LIVE_TIME,
    getWebcastingIframeUrl,
    getSessionTimeMetrics,
    getCurrentTime,
    getDateInIsoFormat,
    attendeeSessionStatus,
    PreSessionExperienceTypes,
    getIsSessionStartDynamic,
} from '../sessionBroadcastUtils';
import PrerecordedVideo from '../VirtualSessions/PrerecordedVideo';
import CounterToBroadcast from '../VirtualSessions/CounterToBroadcast';
import ExternalUrlRedirectModal from '../VirtualSessions/ExternalUrlRedirectModal';
import TimePassed from '../SessionProgressBar';
import Preroll from '../VirtualSessions/Preroll';
import ZoomExternalBreakoutRooms from '../VirtualSessions/ZoomExternalBreakoutRooms';
import ZoomEmbed from '../VirtualSessions/ZoomEmbed';
import ZoomStandbyScreen from '../VirtualSessions/ZoomStandbyScreen';
import AnimatedRestriction from '../VirtualSessions/AnimatedRestriction';
import { LoginRestriction, WithoutCallToActionRestriction } from '../VirtualSessions/RestrictionComponents';
import LiveSessionPreviewImage from '../VirtualSessions/LiveSessionPreviewImage';
import ThirdPartyCookieModal from '../../ThirdPartyCookieModal';
import JoinLiveSessionButton from '../JoinLiveSessionButton';
import SessionCollaboration from '../sessionSections/SessionCollaboration/SessionCollaboration';
import FeatureToggleUtils from 'FeatureToggleUtils';
import classnames from 'classnames';
import {
    startSessionHeartBeat,
    stopSessionHeartBeat,
    snowplowSessionCheckStatus,
    isSnowplowTrackerEnabled,
    trackCrossOriginTab,
    addTicketToGlobalContext
} from '../../../../utils/SnowplowUtils';
import {
    sessionPingInterval,
    sessionCheck,
    acceptableDelta,
} from '../../../../constants/SnowplowConst';
import webcastingType from '../../../../web-common/scripts/enums/webcastingTypeEnum';
import WebcastingWrapper from '../PlayerWrappers/WebcastingWrapper';
import EmbedViewWrapper from '../PlayerWrappers/EmbedViewWrapper';
import StreamPlayerWrapper from '../PlayerWrappers/StreamPlayerWrapper';
import NewRowWrapper from '../PlayerWrappers/NewRowWrapper';
import BlockedSessionContentView from '../VirtualSessions/BlockedSessionContentView';
import { useConcurrentUsersNotifier } from '../VirtualSessions/useConcurrentUsersNotifier';
import config from '../../../../config/config';
import { getAccessTokenName, getAccessToken } from '../../../../AuthToken';
import { getDomainAdjustedPath } from '../../../../bizzaboAjax';
import { blockingDelay } from '../../../../utils/SupportUtils';
import { getInternalWebsiteBaseUrl } from '../../../../web-common/scripts/utils/whitelabelUtils';
import { loginClickOrigin } from '../../../../constants/Enums';
import { Col } from 'react-bootstrap';
import { InteractiveLivestreamFrame } from '../InteractiveLivestreamFrame';
import { useSessionCheckInStatus } from '../useSessionCheckInStatus';
import LoungeWaitingRoom from '../LoungeWaitingRoom/LoungeWaitingRoom';
import classNames from 'classnames';
import { useLoungeWaitingRoom } from '../LoungeWaitingRoom/useLoungeWaitingRoom';
import MoveToNextSessionBanner from '../sessionSections/MoveToNextSessionBanner/MoveToNextSessionBannerContainer';
import { supportedBrowsers, viewController, broadcastTypes, checkInSend } from './constants';
import { sendAuthorizationAnalyticsEvent, isSupportedBrowser, checkVirtualCheckinTicket } from './utils';
import { useBroadcastProviderManager } from './useBroadcastProviderManager';


function LiveBroadcast(props) {
    const {
        session,
        sessionViewType,
        eventUrls,
        isAuthenticated,
        showEmailLogin,
        event,
        recordUrl,
        customColor,
        currentVirtualSessionDetails: virtualSessionDetailsFromReducer,
        userEmail,
        isWebLoginV2Used,
        siteConf,
        user,
        ticketsSelectionData,
        isPreliminaryAccessEnabled,
        setLoginV2SpinnerOrigin,
        loginV2LoadingState,
        setLoginV2OffsetTop,
        setRecordUrl
    } = props;
    const timeZone = event && event['time-zone-id'];
    const { startDate, startMinute } = session;

    const [counterToBroadcast, setCounterToBroadcast] = useState(() => (
        getTimeToSessionStartInMs({ startDate, startMinute, eventTimeZone: timeZone })
    ));
    const [isScheduledStartTimeHasCome, setIsScheduledStartTimeHasCome] = useState(false);
    const [isRedirectModalVisible, setRedirectModalVisibility] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [showThirdPartyCookieModal, setShowThirdPartyCookieModal] = useState(false);
    const isSessionInMoreThan2min = isSessionStartsInMorethan(session, PRE_SESSION_LIVE_TIME, timeZone);
    const isAutoAccess = !isSessionInMoreThan2min && !isSessionEndedMoreThan(session, SESSION_GRACE_TIME, timeZone) && isAuthenticated;

    const [isIframeLoading, setIsIframeLoading] = useState(true);
    const [restrictionReason, setRestrictionReason] = useState(null);
    const [externalSolutionUrl, setExternalSolutionUrl] = useState(null);
    const newrowTab = useRef(null);

    const [virtualSessionDetails, setVirtualSessionDetails] = useState(virtualSessionDetailsFromReducer ?? {});
    const [prerollVideoStartedPlaying, setPrerollVideoStartedPlaying] = useState(false);

    const [playerStarted, setPlayerStarted] = useState(false);
    const showLoungeWaitingRoom = useLoungeWaitingRoom(session, timeZone, counterToBroadcast, playerStarted);

    const { getSessionCheckInStatus, setSessionCheckInStatus } = useSessionCheckInStatus();
    const isQnaEnabled = FeatureToggleUtils.isFeatureEnabled('sessionQna');
    const isQnaEnabledForSession = (session) => session?.qna?.enable;
    const isBizzaboQnaActive = isQnaEnabled && isQnaEnabledForSession(session);
    const isChatEnabled = session?.chat?.enable;

    const sessionId = session.id;
    const eventId = session.eventId;
    const accountId = event['account-id'];
    const recordingImageUrl = session.recordingImageUrl;
    const isMobileDevice = isMobile();

    const tokenCookieName = getAccessTokenName();
    const refreshTokenUrl = getDomainAdjustedPath('/userProfile/oauth/refreshToken');
    const socketConfig = {
        baseUrl: config.realtimeNotificationsHost,
        tokenCookieName,
        refreshTokenUrl,
        accountId,
        eventId,
    };
    const isAvoidConcurrentUsersEnabled = !FeatureToggleUtils.isFeatureEnabled('avoidConcurrentUsersDisabled');
    const [openJoinLeaveSocket, setOpenJoinLeaveSocket] = useState(isAvoidConcurrentUsersEnabled && !getIsSessionStartDynamic(session));
    const extractUIControllerInitialState = () => {
        if (!isAuthenticated) {
            return viewController.NOT_AUTHENTICATED;
        }
        if (isSessionInMoreThan2min) {
            return viewController.NOT_STARTED;
        }
        if (virtualSessionDetails?.prerollSessionResponse && session?.waitingRoom?.type === PreSessionExperienceTypes.PRE_ROLL) {
            return viewController.PRE_ROLL;
        }
        if (virtualSessionDetails?.type === webcastingType.NEWROW) {
            return viewController.NEWROW_IFRAME;
        }
        if (virtualSessionDetails?.type === webcastingType.WEBCASTING) {
            return viewController.WEBCASTING;
        }
        if (virtualSessionDetails?.type === webcastingType.EMBEDDED) {
            return viewController.EMBEDDED;
        }
        if (virtualSessionDetails?.type === webcastingType.VIDEO_PROVIDER) {
            return viewController.VIDEO_PROVIDER;
        }
        if (virtualSessionDetails?.type === webcastingType.INTERACTIVE_VIDEO_PROVIDER) {
            return viewController.INTERACTIVE_VIDEO_PROVIDER;
        }
        if (isAutoAccess) {
            return viewController.AUTO_ACCESS;
        }

        return viewController.NOT_AUTHENTICATED;
    };

    const [interactiveStreamProps, setInteractiveStreamProps] = useState(null);

    const prepareInteractiveLivestreamProps = async(virtualSessionDetails) => {
        let accessResponse = virtualSessionDetails;
        if (!virtualSessionDetails && virtualSessionDetails?.type === undefined) {
            accessResponse = await getVirtualSessionEndPoint(({ sessionId, eventId }));
        }
        const transportConfig = {
            apiUrl: config.apiServer + '/',
            realtimeNotificationsHost: config.realtimeNotificationsHost,
            seismoHost: config.seismoHost,
            headers: {
                Authorization: `Bearer ${getAccessToken()}`
            },
            fetchFunc: makeAjaxRequest,
            accessTokenCookieName: getAccessTokenName(),
            refreshTokenUrl,
        };
        setInteractiveStreamProps({
            transportConfig,
            accessResponse,
            accountId,
            session,
            parentApplication: 'webattendee',
            featureToggles: {
                'ultimate-dual-streaming': FeatureToggleUtils.isFeatureEnabled('ultimate-dual-streaming'),
                'ultimate-media-share': FeatureToggleUtils.isFeatureEnabled('ultimate-media-share'),
            }
        });
    };

    const [uiController, setUiController] = useState(extractUIControllerInitialState());
    const showMoveToNextSessionBanner = uiController !== viewController.NOT_AUTHENTICATED && isScheduledStartTimeHasCome;

    useEffect(() => {
        if (!isAuthenticated && !isSessionInMoreThan2min) {
            sendAnalytics('sessionAccessUnauthenticated', {
                sessionId,
                accountId,
                sessionStatus: analyticsConstants.sessionStatus.atSession,
                result: analyticsConstants.result.failure,
                resultReason: 'notLoggedIn'
            });
        }
    }, []);

    const canPlayWebcastingSession = virtualSessionDetails !== null &&
        !!userEmail &&
        sessionViewType === 'sessionPage' &&
        uiController === viewController.WEBCASTING;

    const webcastUrl = useMemo(() => (
        canPlayWebcastingSession ?
            getWebcastingIframeUrl({
                ...virtualSessionDetails,
                userId: userEmail,
                isBizzaboQnaActive
            }, event) :
            null
    ), [canPlayWebcastingSession, virtualSessionDetails, userEmail, isBizzaboQnaActive, event]);


    const getVirtualSessionDetails = async() => {
        let result = null;
        try {
            result = await getVirtualSessionEndPoint({ sessionId, eventId });
            const isVirtualCheckinTicketExists = checkVirtualCheckinTicket(ticketsSelectionData);
            if (!isVirtualCheckinTicketExists) {
                const fetchedTickets = await getUserTickets(eventId);
                addTicketToGlobalContext(fetchedTickets, true);
            }
            if (result.type === webcastingType.INTERACTIVE_VIDEO_PROVIDER && !interactiveStreamProps) {
                await prepareInteractiveLivestreamProps(result);
            }
            setVirtualSessionDetails(result);
            sendAuthorizationAnalyticsEvent(analyticsConstants.result.success, null, event, sessionId);
        } catch (error) {
            setRestrictionReason(error);
            setUiController(viewController.SESSION_RESTRICTED);
            sendAuthorizationAnalyticsEvent(analyticsConstants.result.failure, error, event, sessionId);
            return;
        }

        if (result.prerollSessionResponse && session?.waitingRoom?.type === PreSessionExperienceTypes.PRE_ROLL) {
            setUiController(viewController.PRE_ROLL);
        } else {
            startBroadcasting(result);
        }
    };

    useEffect(() => {
        const prerollVideoDurationInMillis = (virtualSessionDetails?.prerollSessionResponse?.metadata?.duration || 0) * 1000;
        prerollVideoStartedPlaying && setTimeout(() => {
            startBroadcasting(virtualSessionDetails);
        }, prerollVideoDurationInMillis);
    }, [prerollVideoStartedPlaying]);

    const startBroadcasting = async(sessionDetails) => {
        switch (sessionDetails.type) {
        case webcastingType.NEWROW: {
            if (isSupportedBrowser()) {
                if (isMobileDevice && !(isAvoidConcurrentUsersEnabled || isSnowplowTrackerEnabled())) {
                    redirectToBroadcast(buildNewrowUrl(sessionDetails.token));
                    break;
                }
                setUiController(viewController.NEWROW_IFRAME);
                break;
            } else {
                setUiController(viewController.BROWSER_NOT_SUPPORTED);
                break;
            }
        }
        case webcastingType.WEBCASTING: {
            setUiController(viewController.WEBCASTING);
            break;
        }
        case webcastingType.EMBEDDED: {
            setUiController(viewController.EMBEDDED);
            setIsIframeLoading(true);
            break;
        }
        case webcastingType.EXTERNAL: {
            setUiController(viewController.EXTERNAL);
            setExternalSolutionUrl(sessionDetails.attendeeUrl);
            break;
        }
        case webcastingType.SIMULIVE: {
            const { setRecordUrl } = props;
            setRecordUrl(sessionDetails.url);
            setUiController(viewController.SIMULIVE);
            break;
        }
        case webcastingType.VIDEO_PROVIDER: {
            setUiController(viewController.VIDEO_PROVIDER);
            break;
        }
        case webcastingType.INTERACTIVE_VIDEO_PROVIDER: {
            setUiController(viewController.INTERACTIVE_VIDEO_PROVIDER);
            break;
        }
        case webcastingType.ZOOM: {
            setUiController(viewController.ZOOM);
            break;
        }
        }
    };
    const getInteractiveStreamProps = async() => {
        try {
            await prepareInteractiveLivestreamProps(virtualSessionDetails);
        } catch (error) {
            setRestrictionReason(error);
            setUiController(viewController.SESSION_RESTRICTED);
        }
    };
    useEffect(() => {
        if (uiController === viewController.INTERACTIVE_VIDEO_PROVIDER
            && !interactiveStreamProps) {
            getInteractiveStreamProps();
        }
    }, ([uiController]));

    // Manage broadcast provider state and notifications
    const { availableProviders, currentBroadcastProvider } = useBroadcastProviderManager({
        sessionId,
        eventId,
        accountId,
        virtualSessionDetails,
        enabled: uiController !== viewController.INTERACTIVE_VIDEO_PROVIDER,
    });

    useInterval(() => {
        const timeToStartInMilliseconds = getTimeToSessionStartInMs({ startDate, startMinute, eventTimeZone: timeZone });

        const autoFetchVirtualSessionDetails = [
            viewController.NOT_STARTED,
            viewController.AUTO_ACCESS,
        ].includes(uiController);

        if (
            !isSessionInMoreThan2min
            && !isSessionEndedMoreThan(session, SESSION_GRACE_TIME, timeZone)
            && autoFetchVirtualSessionDetails
        ) {
            getVirtualSessionDetails();
        }

        if (timeToStartInMilliseconds <= 0) {
            setIsScheduledStartTimeHasCome(true);
        }

        setCounterToBroadcast(timeToStartInMilliseconds);

    }, !isScheduledStartTimeHasCome ? 1000 : null, false);

    const sessionFinishTimeOutRef = useRef();

    const uiControllerRef = useRef();

    const setWindowListeners = () => {
        window.addEventListener('pagehide', checkoutVirtualHandler);
    };

    const resetSessionFinishInterval = () => {
        clearInterval(sessionFinishTimeOutRef.current);
        sessionFinishTimeOutRef.current = null;
    };

    const handleHangOutDetection = (data, withCheckInSend) => {
        const internalWebsiteBaseUrl = getInternalWebsiteBaseUrl(event);
        const isBroadCastHasStarted = broadcastTypes.includes(uiControllerRef?.current) && !!virtualSessionDetails?.type;
        const requestObject = {
            eventId, sessionId, internalWebsiteBaseUrl, groupId: event.groupId
        };
        if (isBroadCastHasStarted) {
            if (withCheckInSend) {
                requestObject.status = attendeeSessionStatus.CheckIn;
                requestObject.actionActualTimeStamp = getDateInIsoFormat(data.now, timeZone);
                // here is the couple types of send checkout requests
                // to node and then to agenda services
                // and directly to agenda service
                // changeAttendeeSessionStatusNode(requestObject);
                changeAttendeeSessionStatusAgenda(requestObject);
            } else {
                stopSessionHeartBeat();
                resetSessionFinishInterval();
            }
            requestObject.status = attendeeSessionStatus.CheckOut;
            requestObject.actionActualTimeStamp = getDateInIsoFormat(data.lastTime, timeZone);
            // here is the couple types of send checkout requests
            // to node and then to agenda services
            // and directly to agenda service
            // changeAttendeeSessionStatusNode(requestObject);
            changeAttendeeSessionStatusAgenda(requestObject);
        }
    };

    const runIntervalSessionFinishesCheck = () => {
        const { session: { endDate, endMinute } } = props;
        const sessionDates = { endDate, endMinute, eventTimeZone: timeZone, graceTime: SESSION_GRACE_TIME };
        const delaying = getTimeToSessionEndMS(sessionDates);
        const { sessionEndTime, sessionEndGrace } = getSessionTimeMetrics(sessionDates);
        if (sessionFinishTimeOutRef?.current) {
            resetSessionFinishInterval();
        }
        if (delaying >= 0) {
            let lastTime = getCurrentTime(timeZone);
            const enterSessionTime = getCurrentTime(timeZone);
            const maxInterval = sessionPingInterval + acceptableDelta;

            const hangman = () => {
                const now = getCurrentTime(timeZone);
                const diff = now - lastTime;
                const isSleepHappens = diff > maxInterval;
                const currentlyAfterSessionGraceTime = now > sessionEndTime && now >= sessionEndGrace;
                const currentlyAfterSessionEndBeforeGrace = now >= sessionEndTime && now <= sessionEndGrace;
                const currentlyBeforeSessionEnd = now <= sessionEndTime && now < sessionEndGrace;
                const analyticData = { lastTime, now, sessionEndTime, sessionEndGrace };
                if (isSleepHappens) {
                    if (currentlyAfterSessionGraceTime) {
                        handleHangOutDetection(analyticData);
                    } else if (currentlyAfterSessionEndBeforeGrace || currentlyBeforeSessionEnd) {
                        handleHangOutDetection(analyticData, checkInSend);
                    }
                }
                lastTime = now;
            };
            sessionFinishTimeOutRef.current = setInterval(hangman, sessionPingInterval);
        }
    };

    const isNewrowTabClosed = () => !(newrowTab?.current) || newrowTab?.current?.closed;

    const checkoutVirtualHandler = useCallback((type) => {
        window.removeEventListener('pagehide', checkoutVirtualHandler);
        const pagehideEvent = typeof type !== 'string' ? 'pagehide' : false;
        if (sessionFinishTimeOutRef?.current) {
            resetSessionFinishInterval();
            const isBroadCastHasStarted = broadcastTypes.includes(uiControllerRef?.current);
            if (isBroadCastHasStarted) {
                const checkOutData = {
                    internalWebsiteBaseUrl: getInternalWebsiteBaseUrl(event),
                    sessionId,
                    eventId,
                    groupId: event.groupId,
                    async: true,
                    websiteType: event.websiteType
                };

                if (getSessionCheckInStatus() === sessionCheck.checkIn) {
                    stopSessionHeartBeat();
                    snowplowSessionCheckStatus(sessionCheck.checkOut, pagehideEvent);
                    checkOutVirtualSession(checkOutData);

                    sendAnalytics('sessionCheckOut', {
                        sessionId,
                    });
                }
                if (pagehideEvent) blockingDelay();
            }
        }
        closeNewrowTab();
    }, [getSessionCheckInStatus]);

    useEffect(() => {
        uiControllerRef.current = uiController?.slice() ?? '';
        runIntervalSessionFinishesCheck();
        setWindowListeners();
        return () => {
            checkoutVirtualHandler('willUnMountUseEffect');
        };
    }, [checkoutVirtualHandler]);

    useEffect(() => {
        const isBroadCastHasStarted = broadcastTypes.includes(uiController);
        const userCheckedIn = isBroadCastHasStarted && getSessionCheckInStatus() === sessionCheck.checkOut;

        if (isBroadCastHasStarted) {
            uiControllerRef.current = uiController.slice();
        }

        if (uiController !== viewController.NEWROW_IFRAME) {
            if (userCheckedIn) {
                startSnowplowSession();

                virtualSessionDetails?.type && sendAnalytics('sessionCheckIn', {
                    sessionId,
                });
            }
        } else {
            if (!isMobileDevice && virtualSessionDetails?.isThirdPartyCookiesSupported) {
                if (userCheckedIn) {
                    startSnowplowSession();

                    sendAnalytics('sessionCheckIn', {
                        sessionId,
                    });
                }
            }
            if (!isSupportedBrowser()) {
                setUiController(viewController.BROWSER_NOT_SUPPORTED);
            } else if (!virtualSessionDetails?.isThirdPartyCookiesSupported) {
                setUiController(viewController.THIRD_PARTY_COOKIES_BLOCKED);
                setShowThirdPartyCookieModal(true);
            }
        }
    }, [uiController, startSnowplowSession]);

    const startSnowplowSession = useCallback(() => {
        if (broadcastTypes.includes(uiController) && virtualSessionDetails?.type && getSessionCheckInStatus() === sessionCheck.checkOut) {
            // send analytic for check in mysql
            getVirtualSessionEndPoint(({ sessionId, eventId, shouldSendCheckin: true }));
            setSessionCheckInStatus(sessionCheck.checkIn);
            startSessionHeartBeat(sessionPingInterval);
            snowplowSessionCheckStatus(sessionCheck.checkIn);
        }
    }, [uiController, virtualSessionDetails]);

    const {
        isConcurrentUsers,
        connectConcurrentUsersNotifier,
        disconnectConcurrentUsersNotifier
    } = useConcurrentUsersNotifier({
        session,
        userEmail,
        socketConfig,
        isFeatureEnabled: openJoinLeaveSocket,
        uiController,
        virtualSessionDetails,
        ticketsSelectionData
    });

    const isSessionContentBlocked = isAvoidConcurrentUsersEnabled && isConcurrentUsers;

    useEffect(() => {
        if (isSessionContentBlocked) {
            if (uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED && showThirdPartyCookieModal) {
                setShowThirdPartyCookieModal(false);
            }
            if (document.pictureInPictureElement) {
                document.exitPictureInPicture();
            }
            newrowTab.current?.close?.();
        }
    }, [isSessionContentBlocked]);

    const handleRedirectToExternal = () => {
        window.open(externalSolutionUrl);
        setRedirectModalVisibility(false);
    };

    const openNewrowTab = () => {
        const isNewSession = isNewrowTabClosed();
        if (isNewSession) {
            if (isAvoidConcurrentUsersEnabled) {
                connectConcurrentUsersNotifier();
            }
        } else {
            closeNewrowTab(false);
        }
        const url = buildNewrowUrl(virtualSessionDetails?.token);
        newrowTab.current = window.open(url);
        monitorNewrowTab(isNewSession);
    };

    const closeNewrowTab = (isNewSession = true) => {
        if (isAvoidConcurrentUsersEnabled && isNewSession) {
            disconnectConcurrentUsersNotifier();
        }
        newrowTab.current?.focus?.();
        newrowTab.current?.close?.();
    };

    const monitorNewrowTab = async(isNewSession = true) => {
        if (isNewSession && isSnowplowTrackerEnabled()) {
            runIntervalSessionFinishesCheck();
            startSnowplowSession();
        }
        const workerboundTabHasClosed = await trackCrossOriginTab(newrowTab.current);
        if (workerboundTabHasClosed && isNewrowTabClosed()) {
            if (isSnowplowTrackerEnabled()) {
                checkoutVirtualHandler('newRowTabClosed');
            } else {
                closeNewrowTab();
            }
        }
    };

    const handleWatchFromHere = () => {
        if (uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED) {
            setShowThirdPartyCookieModal(true);
            return;
        }
        if (uiController === viewController.NEWROW_IFRAME && isMobileDevice) {
            setRedirectModalVisibility(true);
            return;
        }
        connectConcurrentUsersNotifier();
    };

    const handleRedirectConfirmation = () => {
        uiController === viewController.NEWROW_IFRAME && (isSnowplowTrackerEnabled() || isAvoidConcurrentUsersEnabled)
            ? openNewrowTab()
            : handleRedirectToExternal();
        setRedirectModalVisibility(false);
    };

    const onLivestreamStateChange = (state) => {
        const isLive = state === StreamState.STARTED || state?.isLive;
        setPlayerStarted(isLive);
        setOpenJoinLeaveSocket(isLive);
    };


    const showLiveBroadcastPreview =
        uiController === viewController.NOT_STARTED ||
        uiController === viewController.SESSION_RESTRICTED ||
        uiController === viewController.NOT_AUTHENTICATED ||
        uiController === viewController.EXTERNAL ||
        uiController === viewController.ZOOM ||
        (uiController === viewController.SIMULIVE && !isScheduledStartTimeHasCome) ||
        uiController === viewController.AUTO_ACCESS ||
        (uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED && !isSessionContentBlocked);
    const isSupportedUiController =
        uiController === viewController.SESSION_RESTRICTED ||
        uiController === viewController.NOT_AUTHENTICATED ||
        uiController === viewController.EMBEDDED ||
        uiController === viewController.WEBCASTING ||
        uiController === viewController.EXTERNAL ||
        uiController === viewController.NEWROW_IFRAME ||
        uiController === viewController.SIMULIVE ||
        uiController === viewController.NOT_STARTED ||
        uiController === viewController.PRE_ROLL ||
        uiController === viewController.AUTO_ACCESS ||
        uiController === viewController.VIDEO_PROVIDER ||
        uiController === viewController.INTERACTIVE_VIDEO_PROVIDER ||
        uiController === viewController.ZOOM;
    const showLiveBroadcastFooter = isSupportedUiController || uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED;
    const showSessionCollaborations = (isChatEnabled || isBizzaboQnaActive) && virtualSessionDetails?.type && isSupportedUiController;
    const uiControllersCoveredWithAvoidConcurrent =
        uiController === viewController.EMBEDDED ||
        uiController === viewController.WEBCASTING ||
        uiController === viewController.NEWROW_IFRAME ||
        uiController === viewController.SIMULIVE ||
        uiController === viewController.VIDEO_PROVIDER ||
        uiController === viewController.INTERACTIVE_VIDEO_PROVIDER ||
        uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED;

    const shouldBeMaxWidth = uiController === viewController.INTERACTIVE_VIDEO_PROVIDER;

    // Calculate current provider based on socket updates
    const currentProvider = useMemo(() => {
        if (currentBroadcastProvider && availableProviders.length > 0) {
            const provider = availableProviders.find(
                (p) => p.videoProviderType === currentBroadcastProvider
            );
            if (provider) {
                return provider;
            }
        }

        // fallback: Use first available provider or virtualSessionDetails
        return (
            availableProviders[0] || {
                attendeeUrl: virtualSessionDetails?.attendeeUrl,
                videoProviderType: virtualSessionDetails?.videoProviderType,
                streamId:
                    virtualSessionDetails?.streamId ||
                    virtualSessionDetails?.broadcastAccess?.[0]?.streamId,
            }
        );
    }, [availableProviders, currentBroadcastProvider, virtualSessionDetails]);

    const captionsUrl = useMemo(() => (
        virtualSessionDetails?.captionsUrl
            ?? currentProvider?.captionsUrl
            ?? virtualSessionDetails?.broadcastAccess?.[0]?.captionsUrl
            ?? null
    ), [virtualSessionDetails, currentProvider]);

    return (
        <Fragment>
            <div className={classnames('live-broadcast-container-layout')} style={{ width: 'inherit' }}>
                <div className='live-broadcast-virtual-session-container' style={{ maxWidth: shouldBeMaxWidth ? '100%' : 'inherit' }}>
                    <div className={classNames(showLoungeWaitingRoom && 'aspect-ratio-lounge-normalizer')}>
                        {
                            uiController === viewController.EXTERNAL &&
                            <div className="color-1-background-opacity bz-flex-row">
                                <JoinLiveSessionButton
                                    event={event}
                                    me={user}
                                    session={session}
                                    eventUrls={eventUrls}
                                    showEmailLogin={showEmailLogin}
                                    setVirtualSessionDetails={setVirtualSessionDetails}
                                    btnText="Join Session"
                                    showRegisterAndLoginModal={showEmailLogin}
                                    siteConf={siteConf}
                                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                                    ticketsSelectionData={ticketsSelectionData}
                                    btnClass={'external-solution-btn'}
                                    virtualSessionDetails={virtualSessionDetails}
                                    analyticData={{
                                        clickOrigin: loginClickOrigin.session.join('Join Broadcast'),
                                        sessionId,
                                    }}
                                />
                            </div>
                        }
                        {
                            uiController === viewController.NEWROW_IFRAME && !isSessionContentBlocked &&
                            <NewRowWrapper
                                iframeUrl={buildNewrowUrl(virtualSessionDetails?.token)}
                                isIframeLoading={isIframeLoading}
                                setIsIframeLoading={setIsIframeLoading}
                                recordingImageUrl={recordingImageUrl}
                                setRedirectModalVisibility={setRedirectModalVisibility}
                            />
                        }
                        {
                            uiController === viewController.INTERACTIVE_VIDEO_PROVIDER && interactiveStreamProps && !isSessionContentBlocked &&
                            <InteractiveLivestreamFrame
                                accountId={accountId}
                                event={event}
                                groupId={event.groupId}
                                user={user}
                                onStateChanged={onLivestreamStateChange}
                                skipBeforeStreamMessage={showLoungeWaitingRoom}
                                captionsEnabled={virtualSessionDetails?.captionsEnabled}
                                captionsUrl={captionsUrl}
                                {...interactiveStreamProps}
                            />
                        }
                        {
                            uiController === viewController.WEBCASTING && canPlayWebcastingSession && !isSessionContentBlocked &&
                            <WebcastingWrapper
                                url={webcastUrl}
                            />
                        }
                        {
                            uiController === viewController.EMBEDDED && !isSessionContentBlocked &&
                            <EmbedViewWrapper
                                isBizzaboQnaActive={isBizzaboQnaActive}
                                virtualSessionDetails={virtualSessionDetails}
                                isIframeLoading={isIframeLoading}
                                setIsIframeLoading={setIsIframeLoading}
                                canPlay={!showLoungeWaitingRoom}
                            />
                        }
                        {
                            uiController === viewController.VIDEO_PROVIDER && virtualSessionDetails && !isSessionContentBlocked &&
                            <StreamPlayerWrapper
                                streamUrl={currentProvider.attendeeUrl}
                                providerType={currentProvider.videoProviderType}
                                session={session}
                                user={user}
                                eventId={eventId}
                                overridePlayerConfigs={{ clickToPlay: false }}
                                captionsEnabled={virtualSessionDetails?.captionsEnabled}
                                turnOnCaptionsForAttendees={virtualSessionDetails?.turnOnCaptionsForAttendees}
                                captionsUrl={captionsUrl}
                                socketConfig={socketConfig}
                                streamId={currentProvider.streamId || virtualSessionDetails.broadcastAccess?.[0]?.streamId}
                                onStateChanged={onLivestreamStateChange}
                                skipBeforeStreamMessage={showLoungeWaitingRoom}
                            />
                        }
                        {
                            uiController === viewController.SIMULIVE && !isSessionContentBlocked &&
                            <PrerecordedVideo
                                sessionId={sessionId}
                                uiController={uiController}
                                startDate={startDate}
                                startMinute={startMinute}
                                timeZone={timeZone}
                                recordUrl={recordUrl}
                                captions={virtualSessionDetails?.captions}
                                availableHls={virtualSessionDetails.availableHls}
                                isScheduledStartTimeHasCome={isScheduledStartTimeHasCome}
                                userId={user?.id}
                                userEmail={userEmail}
                                sessionTitle={session?.title}
                                eventId={eventId}
                                captionsEnabled={virtualSessionDetails?.captionsEnabled}
                                turnOnCaptionsForAttendees={virtualSessionDetails?.turnOnCaptionsForAttendees}
                                session={session}
                            />
                        }
                        {
                            uiController === viewController.PRE_ROLL &&
                            (
                                <Col className="make-relative preroll-video">
                                    <Preroll
                                        videoUrl={virtualSessionDetails?.prerollSessionResponse?.assetUrl}
                                        availableHls={virtualSessionDetails?.prerollSessionResponse?.metadata?.availableHls}
                                        setPrerollVideoStartedPlaying={setPrerollVideoStartedPlaying}
                                    />
                                </Col>
                            )
                        }
                        {
                            uiControllersCoveredWithAvoidConcurrent && isSessionContentBlocked &&
                            <BlockedSessionContentView
                                recordingImageUrl={recordingImageUrl}
                                onWatchFromHere={handleWatchFromHere}
                            />
                        }
                        {
                            uiController === viewController.BROWSER_NOT_SUPPORTED &&
                            <div className="not-supported-block">
                                <div className="header">It looks like you are using a browser which is not supported</div>
                                <div className="sub-header">You are using an outdated browser which doesn’t support the finer things we built for this website. Please use one of the following browsers:</div>
                                <div className="browsers-block">
                                    {supportedBrowsers.map(browser =>
                                        <div className="browser-block" key={browser.name}>
                                            <img
                                                src={browser.imgSrc}
                                                alt={browser.name}
                                                height="44"
                                                width="44" />
                                            <div className="browser-name">
                                                {browser.name} <span className="browser-version">{browser.version}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }

                        {showLiveBroadcastPreview && (
                            <div className="live-broadcast-preview">
                                {recordingImageUrl && (
                                    <LiveSessionPreviewImage previewUrl={recordingImageUrl} />
                                )}
                                {uiController === viewController.ZOOM && (
                                    <ZoomStandbyScreen hasStarted={isScheduledStartTimeHasCome}>
                                        {isMobileDevice ?
                                            <ZoomExternalBreakoutRooms
                                                participantUrl={virtualSessionDetails?.url}
                                                sessionId={sessionId}
                                                eventId={eventId}
                                            /> :
                                            <ZoomEmbed
                                                me={user}
                                                participantUrl={virtualSessionDetails?.url}
                                                accountId={accountId}
                                                eventId={eventId}
                                                sessionId={sessionId}
                                            />
                                        }
                                    </ZoomStandbyScreen>
                                )}
                                {restrictionReason && (
                                    <AnimatedRestriction
                                        transitionName="fade-out"
                                        isVisible={!isMinimized && !isMobileDevice}
                                        isMinimized={isMinimized}
                                        minimize={() => setIsMinimized(true)}
                                        customColor={customColor}
                                    >
                                        <WithoutCallToActionRestriction
                                            text={getRestrictionReason({ reason: restrictionReason })}
                                        />
                                    </AnimatedRestriction>
                                )}
                                {uiController === viewController.NOT_AUTHENTICATED && !isPreliminaryAccessEnabled && (
                                    <AnimatedRestriction
                                        transitionName="fade-out"
                                        isVisible={!isMinimized && !isMobileDevice}
                                        isMinimized={isMinimized}
                                        minimize={() => setIsMinimized(true)}
                                        customColor={customColor}
                                    >
                                        <LoginRestriction
                                            text="To join the session you should be logged in and registered to the event"
                                            onLoginClick={showEmailLogin}
                                            eventUrls={eventUrls}
                                            setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                                            loginV2LoadingState={loginV2LoadingState}
                                            isWebLoginV2Used={isWebLoginV2Used}
                                            setLoginV2OffsetTop={setLoginV2OffsetTop}
                                            isWidget={siteConf?.isWidget}
                                            analyticData={{
                                                clickOrigin: loginClickOrigin.session.restriction,
                                                sessionId,
                                            }}
                                        />
                                    </AnimatedRestriction>
                                )}
                                {(uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED) &&
                                    <AnimatedRestriction
                                        transitionName="fade-out"
                                        isVisible={!isMinimized && !isMobileDevice}
                                        isMinimized={isMinimized}
                                        minimize={() => setIsMinimized(true)}
                                        customColor={customColor}
                                    >
                                        <WithoutCallToActionRestriction
                                            text={
                                                <div className="text-center padding-top-xs">
                                                    <p>
                                                        To join the session you should{' '}
                                                        <a
                                                            href="https://welcome.bizzabo.com/en/en/3rd-party-cookies-how-to"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="color-1 "
                                                        >
                                                            enable third party cookies
                                                        </a>
                                                    </p>
                                                    <p>
                                                        Or open this broadcast in a{' '}
                                                        <button
                                                            className="color-1 custom-font background-none border-transparent padding-none"
                                                            onClick={openNewrowTab}
                                                        >
                                                            new tab
                                                        </button>
                                                    </p>
                                                </div>
                                            }
                                        />
                                    </AnimatedRestriction>
                                }
                            </div>
                        )}
                        {showLoungeWaitingRoom && <LoungeWaitingRoom session={session} me={user} timeToStartInMilliseconds={counterToBroadcast} />}
                    </div>
                </div>
                {showLiveBroadcastFooter &&
                    <div className="live-broadcast-footer">
                        <div id="live-broadcast-footer-left-container" className="left-container">
                            {isScheduledStartTimeHasCome ? (
                                <TimePassed
                                    startDate={session.startDate}
                                    startMinute={session.startMinute}
                                    endDate={session.endDate}
                                    endMinute={session.endMinute}
                                    eventTimeZone={timeZone}
                                />
                            ) : (
                                <CounterToBroadcast counter={counterToBroadcast} />
                            )}
                        </div>
                        <div className="right-container">
                            {restrictionReason && (
                                <AnimatedRestriction
                                    transitionName="fade-in"
                                    isVisible={isMinimized || isMobileDevice}
                                    customColor={customColor}
                                    isMinimized
                                >
                                    <WithoutCallToActionRestriction
                                        text={getRestrictionReason({ reason: restrictionReason })}
                                    />
                                </AnimatedRestriction>
                            )}
                            {uiController === viewController.NOT_AUTHENTICATED && (
                                <AnimatedRestriction
                                    transitionName="fade-in"
                                    isVisible={isMinimized || isMobileDevice}
                                    customColor={customColor}
                                    isMinimized
                                >
                                    <LoginRestriction
                                        text="To join the session you should be logged in and registered to the event"
                                        onLoginClick={showEmailLogin}
                                        eventUrls={eventUrls}
                                        isWebLoginV2Used={isWebLoginV2Used}
                                        loginV2LoadingState={loginV2LoadingState}
                                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                                        setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                                        isWidget={siteConf?.isWidget}
                                        analyticData={{
                                            clickOrigin: loginClickOrigin.session.restriction,
                                            sessionId,
                                        }}
                                    />
                                </AnimatedRestriction>
                            )}
                            {(uiController === viewController.THIRD_PARTY_COOKIES_BLOCKED && !isSessionContentBlocked) &&
                                <AnimatedRestriction
                                    transitionName="fade-out"
                                    isVisible={isMinimized || isMobileDevice}
                                    isMinimized
                                    customColor={customColor}
                                >
                                    <WithoutCallToActionRestriction
                                        text={
                                            <div className="text-center padding-top-xs">
                                                <p>
                                                    To join the session you should{' '}
                                                    <a
                                                        href="https://welcome.bizzabo.com/en/en/3rd-party-cookies-how-to"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="color-1 "
                                                    >
                                                        enable third party cookies
                                                    </a>
                                                </p>
                                                <p>
                                                    Or open this broadcast in a{' '}
                                                    <button
                                                        className="color-1 custom-font background-none border-transparent padding-none"
                                                        onClick={openNewrowTab}
                                                    >
                                                        new tab
                                                    </button>
                                                </p>
                                            </div>
                                        }
                                    />
                                </AnimatedRestriction>
                            }
                        </div>
                    </div>}
                {showSessionCollaborations &&
                    <SessionCollaboration
                        virtualSessionDetails={virtualSessionDetails}
                        availableTabs={{ ringEngagementPanel: showSessionCollaborations, chat: virtualSessionDetails?.chatEnabled }}
                        showEmailLogin={showEmailLogin}
                        isAuthenticated={isAuthenticated}
                        siteConf={siteConf}
                        session={session}
                        user={user}
                        event={event} />
                }
                <ExternalUrlRedirectModal
                    show={isRedirectModalVisible}
                    onHide={() => setRedirectModalVisibility(false)}
                    onContinue={handleRedirectConfirmation}
                />
                <ThirdPartyCookieModal
                    show={showThirdPartyCookieModal}
                    onHide={() => setShowThirdPartyCookieModal(false)}
                    onNewTabSolution={openNewrowTab}
                    isInteractSession
                />
            </div>
            {showMoveToNextSessionBanner &&
                <MoveToNextSessionBanner
                    siteConf={siteConf}
                    timeZone={timeZone}
                    event={event}
                    user={user}
                    eventUrls={eventUrls}
                    session={session}
                    setRecordUrl={setRecordUrl}
                />
            }
        </Fragment>
    );
}

export default LiveBroadcast;
